export default "__VITE_ASSET__DiQLv$M7__"